import React, {Component} from 'react';
import {connect} from 'react-redux';

class Slider extends Component {
    constructor(props) {
        super(props);
        this.change = this.change.bind(this);
    }
    
    change (e) {
        const val = e.target.value;
        this.props.dispatch(this.props.action(parseFloat(val)));
        
        if (this.props.label === '透過率') window.changeRsltPlOpa(val);
    }
    
    render() {
        return (
            <div className={this.props.blank ? 'l-row l-blank' : 'l-row'}>
                <label>{this.props.label + '：'}</label>
                <input className='slider' type='range' min = '0' max = '100' step = '10' value={this.props.value} onChange={this.change} />
                <p>{this.props.value}</p>%
            </div>
        );
    }
};

export default connect()(Slider);